import React from "react";
import iconNameMap from "@Pages/Search/components/SearchListItem/components/FeatureTags/iconNameMap";
import TickMark from "@Icons/TickMark";
import ErrorBoundary from "@Components/ErrorBoundary";

const getIconName = (amenityName = "", height = "", width = "") => {
  const iconMap = iconNameMap();
  const keywords = Object.keys(iconMap);
  const nameLower = amenityName?.toLowerCase() ?? "";
  // Snake_case filter values ("desk_chair") and display labels ("Desk & Chair")
  // must hit the same keyword. Exact key match stays first so values like
  // "non_ensuite" are not reduced to the shorter "ensuite" token.
  const tokens = nameLower.split(/[^a-z0-9]+/).filter(Boolean);
  let matchedKeyword = keywords.find((keyword) => keyword === nameLower);
  if (!matchedKeyword) {
    matchedKeyword = keywords.find((keyword) => tokens.includes(keyword));
  }
  if (!matchedKeyword) {
    matchedKeyword = keywords.find((keyword) => nameLower.includes(keyword));
  }

  if (matchedKeyword) {
    const Icon = iconMap[matchedKeyword as keyof typeof iconMap];
    const iconWithProps =
      Icon && typeof Icon !== "string"
        ? React.cloneElement(Icon as React.ReactElement, {
            ...(height ? { height } : null),
            ...(width ? { width } : null),
          })
        : Icon;

    return (
      <ErrorBoundary noErrorLog addFallbackIcons>
        {height || width ? (
          <div
            style={{
              ...(height ? { height } : { height: "16px" }),
              ...(width ? { width } : { width: "16px" }),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {iconWithProps}
          </div>
        ) : (
          iconWithProps
        )}
      </ErrorBoundary>
    );
  }
  return (
    <div
      style={{
        ...(height ? { height } : { height: "16px" }),
        ...(width ? { width } : { width: "16px" }),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TickMark />
    </div>
  );
};

export default getIconName;
